import { t } from 'i18next'

export const STATUSES_OPTIONS = {
  active: {
    label: t('admin:brands.table.statuses.active'),
    key: 'ACTIVE',
  },
  inactive: {
    label: t('admin:brands.table.statuses.inactive'),
    key: 'INACTIVE',
  },
}
